import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-authenticate-modal',
  templateUrl: './authenticate-modal.component.html',
  styleUrls: ['./authenticate-modal.component.scss']
})
export class AuthenticateModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() label: string = '';

  form!: UntypedFormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      signature: [null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9'-.]+(?: [a-zA-Z0-9'-.]+)*$/), Validators.maxLength(200)]],
    });
  }

  submit({ value, valid }: { value: any, valid: boolean }) {
    if (!valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.activeModal.close(value.signature);
  }

  cancel() {
    this.activeModal.dismiss();
  }

  get signatureControl() {
    return this.form.get('signature');
  }

}
